<template>
  <div>
    <b-row class="my-3 justify-content-center">
      <b-col cols="12">
        <b-row>
          <b-col cols="6">
            <b-button
              class="btn-block"
              squared
              :class="{
                'agv btn-primary': contact.entity_type == entityTypes.individual,
                'agv btn-outline-primary': contact.entity_type != entityTypes.individual,
              }"
              variant="none"
              @click="setEntityType(entityTypes.individual)"
              ><b>Particulier</b></b-button
            >
          </b-col>
          <b-col cols="6">
            <b-button
              class="btn-block"
              squared
              variant="none"
              :class="{
                'btn-primary': contact.entity_type == entityTypes.legal,
                'btn-outline-primary': contact.entity_type != entityTypes.legal,
              }"
              @click="setEntityType(entityTypes.legal)"
              ><b>Professionnel</b></b-button
            >
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- gender | lastname | firstname -->
    <b-row v-if="contact.entity_type == entityTypes.individual">
      <b-col cols="5" sm="5" md="2">
        <label>{{ $t("general.Civilité") }}</label>
        <b-form-select
          :value="contact.gender"
          :options="genderOptions"
          @change="updateContact('gender', $event)"
        />
      </b-col>
      <b-col cols="10" sm="8" md="5">
        <label>{{ $t("general.Nom") }}</label>
        <ValidationProvider
          ref="vee-contact-lastname"
          v-slot="{ errors, classes }"
          :name="'lastname'"
          rules="required"
        >
          <b-input :value="contact.lastname" @input="updateContact('lastname', $event)" />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
      <b-col cols="10" sm="8" md="5">
        <label>{{ $t("general.Prénom") }}</label>
        <b-input :value="contact.firstname" @input="updateContact('firstname', $event)" />
      </b-col>
    </b-row>
    <b-row v-if="contact.entity_type == entityTypes.legal">
      <b-col cols="10" sm="12" md="12">
        <label>Raison sociale</label>
        <ValidationProvider
          ref="vee-contact-lastname"
          v-slot="{ errors, classes }"
          :name="'raison sociale'"
          rules="required"
        >
          <b-input :value="contact.lastname" @input="updateContact('lastname', $event)" />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    contact: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    updateContact(key, value) {
      this.$emit("updateContact", key, value);
    },
    setEntityType(type) {
      this.$emit("updateContact", "entity_type", type);
      if (type == this.entityTypes.legal) {
        this.$emit("updateContact", "gender", null);
      }
    },
  },
};
</script>
